import React from 'react';
import styles from './SkeletonLoader.module.scss';

interface ISkeletonLoaderProps {
  style?: React.CSSProperties;
}

function SkeletonLoader({ style }: Readonly<ISkeletonLoaderProps>): JSX.Element {
  return (
    <div className={`${styles.skeleton} ${styles.animate}`} style={style} />
  );
}

export default SkeletonLoader;
